export default "__VITE_ASSET__BytbKuYH__"